import {
  REQUEST_HERO_BANNER, UPDATE_HERO_BANNER, CREATE_HERO_BANNER,
} from '../actionTypes';

export const currentHeroBannerGet = () => ({
  type: REQUEST_HERO_BANNER,
});

export const currentHeroBannerUpdate = (id, data) => ({
  type: UPDATE_HERO_BANNER,
  payload: { id, data },
});

export const heroBannerCreate = (data) => ({
  type: CREATE_HERO_BANNER,
  payload: data,
});
